import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface MenuState {
    isOpen: string[]
    opened: boolean
}

const initialState: MenuState = {
    isOpen: [],
    opened: true
};

const menuSlice = createSlice({
    name: "menu",
    initialState,
    reducers: {
        openMenu: (state, action: PayloadAction<string>) => {
            state.isOpen = [action.payload]
        },
        setMenu: (state, action: PayloadAction<boolean>) => {
            state.opened = action.payload
        },
    }
})

export const {
    openMenu,
    setMenu,
} = menuSlice.actions;
export default menuSlice.reducer;
